import { useHistory, useParams } from "react-router";
import { useManageFeatureInstanceDetails } from "entity-app/hooks/feature-details-page";
import { useContext } from "react";
import {
  isPermissionNotGrantted,
  ProjectContext
} from "context/ProjectProvider";
import { ProjectPermissionEnum } from "constants/index";
import FeatureHeader from "pages/preconstruction-details/components/bid-package-header";
import { FeatureTypes } from "entity-app/constants";
import useFeatureLogNavReader from "hooks/use-feature-log-nav-reader";
import DesignPackageDetailsTab from "./design-package-detail-tab";
import usePageTitle from "hooks/use-page-title";
import { formatEntityTitle } from "config/page-titles";

function DesignPackageDetailPage() {
  const history = useHistory();
  const { projectId, designPackageId } = useParams() as any;

  const { featureInstanceData, actions } = useManageFeatureInstanceDetails(
    designPackageId,
    FeatureTypes.DESIGN_PACKAGE
  );

  usePageTitle(
    formatEntityTitle(featureInstanceData?.number, featureInstanceData?.title)
  );

  const goBackToList = () => {
    history.push(`/project/${projectId}/design-packages/${designPackageId}`);
  };
  const { tokenContents } = useContext(ProjectContext);
  const cannotWriteAccessOfDesignPackage = isPermissionNotGrantted(
    ProjectPermissionEnum.DesignPackageWrite,
    tokenContents?.role ?? ""
  );

  const navigator = useFeatureLogNavReader({
    feature: "design-packages",
    projectId,
    currentId: designPackageId,
    toPath: (id) => `/project/${projectId}/design-packages/${id}/details`
  });

  return (
    <div className="grow flex-col bg-ciq-gray-50">
      <FeatureHeader
        title="Design Package Details"
        actions={actions}
        number={featureInstanceData?.number}
        headerTitle={featureInstanceData?.title}
        status={featureInstanceData?.feature_workflow_instance?.milestone_state}
        disabled={cannotWriteAccessOfDesignPackage}
        goBackToList={goBackToList}
        feature="DESIGN_PACKAGE"
        featureInstanceData={featureInstanceData}
        navigator={navigator}
      />

      <DesignPackageDetailsTab
        key={designPackageId}
        featureInstanceData={featureInstanceData}
        actions={actions}
        featureId={designPackageId}
      />
    </div>
  );
}

export default DesignPackageDetailPage;
